import script from "./AllFilesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AllFilesModal.vue?vue&type=script&setup=true&lang=js"

import "./AllFilesModal.vue?vue&type=style&index=0&id=a0ee2072&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0ee2072"]])

export default __exports__